import TermDataList from '../TermDataList';
import WordDataList from '../WordDataList';
import DomainDataList from '../DomainDataList';
import ProjectList from '../ProjectList';
import MenuManagement from '../MenuManagement';
import SystemSettingsPage from '../SystemSettingsPage'; // 추가
import GroupManagement from '../GroupManagement';
import UserManagement from '../UserManagement';
import AuthorityManagement from '../AuthorityManagement';
import APIManagement from '../APIManagement';
import EventManagement from '../EventManagement';
import FileManagement from '../FileManagement';
import BoardPage from '../BoardPage';

// rteKey -> Component 매핑
export const componentRegistry = {
  PROJECT_LIST: ProjectList,
  TERM_LIST: TermDataList,
  WORD_LIST: WordDataList,
  DOMAIN_LIST: DomainDataList,
  MENU_MANAGE: MenuManagement,
  SYSTEM_SETTINGS: SystemSettingsPage, // 추가
  GROUP_MANAGE: GroupManagement,
  USER_MANAGE: UserManagement,
  AUTHORITY_MANAGE: AuthorityManagement,
  API_MANAGE: APIManagement,
  EVENT_MANAGE: EventManagement,
  FILE_MANAGE: FileManagement,
  BOARD: BoardPage,
  BOARD_HOME: BoardPage,
  BOARD_LIST: BoardPage,
};

export const resolveComponent = (rteKey) => componentRegistry[rteKey] || null;
